import React from 'react'
import { ActionList } from '../../legacy-design-system/action'
import { AttackEvent } from './shared'

interface ActionProps {
  readonly organizationID: string
}

export function BulkActionList(_props: ActionProps) {
  return <ActionList large>Actions</ActionList>
}

interface FilteredActionProps {
  readonly organizationID: string
  readonly selectedCount: number
  readonly attackEvents: AttackEvent[]
  readonly excludedAttackEvents: AttackEvent[]
  readonly filters: {
    readonly filterText: string
    readonly quickFilter: string
    readonly aggregations: Record<string, string[]>
  }
}

export function FilteredActionList(_props: FilteredActionProps) {
  return <ActionList large>Actions</ActionList>
}
